import React from 'react';

import { Stack } from '@atlaskit/primitives/compiled';

import type { Snippet } from '../snippetTypes.ts';

import { SnippetPanelItem } from './SnippetPanelItem.tsx';

export const SnippetPanelList = ({ snippets }: { snippets: Snippet[] }) => {
	return (
		<Stack>
			{snippets?.map((snippet) => (
				<SnippetPanelItem key={snippet.snippetId} snippet={snippet} />
			))}
		</Stack>
	);
};
